export default __webpack_public_path__ + "static/barcelona_code_school_campus_-9-5638821f4f4c5a052ac69f62a616744a.jpg";